import { atom } from "recoil";

export const clientStore = atom({
	key: "clientStore",
	default: {
		loaded: false,
		data: [],
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
		currentOption: {
			type: [{ value: "id", label: "id" }, { value: "name", label: "name" }],
		},
		currentSearch: "",
		currentSearchType: null,
		sorting: {
			sortingColumn: {
				order: "DESC",
				column: "id",
			},
			isDescending: true,
		},
		pagination: {
			current: 1,
			total: 0,
			count: 0,
		},
	},
});
